import { Box } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

const BULLET_SIZE = 12;

export const StyledPagination = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
    marginBottom: theme.spacing(6),
  },
}));

export const StyledPaginationBullet = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
  width: BULLET_SIZE,
  height: BULLET_SIZE,
  borderRadius: '50%',
  cursor: 'pointer',
  flexShrink: 0,
  backgroundColor: active
    ? theme.palette.primary.main
    : theme.palette.text.fifth,
}));
